<template>  
  <VUEModal :Titolo="this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_MOD_GRAFICHE',this.LinguaUtente)"
            :Programma="'DMSEW'"
            :Altezza="AltezzaPopup"
            :Larghezza="'1000px'"
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="ChiudiPopup" @onClickConfermaModal="ConfermaPopup">
    <template v-slot:Body>

      <VUEColorPicker :Popup="PopupColorPicker"
                      Programma="DMSEW"
                      :Colore="ColoreInModifica"
                      @OnClickConfermaPopup="ConfermaColore()"
                      @OnClickChiudiPopup="AnnullaColore()" />
           
      <div style="margin-bottom: 40px; width: 100%;">
        <div class="form-control ZMPopupSelectionTab" style="width:50%;" :style="TabSelezionato == Tabs.Impostazioni ? {'background-color' : Arancione, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Impostazioni">{{Tabs.Impostazioni}}</div>
        <div class="form-control ZMPopupSelectionTab" style="width:50%;" :style="TabSelezionato == Tabs.Allarmi     ? {'background-color' : Arancione, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Allarmi">{{Tabs.Allarmi}}</div>
      </div>

      <div v-if="TabSelezionato == Tabs.Impostazioni">

        <div class="ZMSeparatoreScheda" style="margin-top: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMP_GEN',this.LinguaUtente) }}</div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_COLORE_BG',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.Background}" @click="ApriPopupColorPicker(ObjGrafico.Background, 'background')">&nbsp;</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_DISEGNA_BORDI',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.DrawBorders">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_COLORE_GRAFICO',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.Color}" @click="ApriPopupColorPicker(ObjGrafico.Color, 'graph_color')">&nbsp;</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_SPESSORE_GRAFICO',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.PenWidth">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <!-- È STATO RICHIESTO DI PERMETTERE SOLO I MARKUP DI TIPO CERCHIO PIENO -->
          <!-- <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">Tipo markup</label>
            <select class="form-control" style="width: 40%" v-model="ObjGrafico.MarkupScelto">
              <option v-for="Markup in ListaMarkup" :key="Markup.Nome">{{Markup.Nome}}</option>
            </select>
          </div>
          <div style="width:20px;float:left">&nbsp;</div> -->
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); /*justify-content: right*/ justify-content: left;">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_DIM_MARKUP',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.MarkupWidth">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 130px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_BOLD_TEXT',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" @change="ObjGrafico.AxisY.FontWeight = ObjGrafico.AxisX.FontWeight = UsaGrassetto ? 'bolder' : 'normal'" v-model="UsaGrassetto">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 50%; justify-content: left">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 160px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_MOSTRA_SIDE_TXT',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" @change="ObjGrafico.AxisY.DrawLabels = ObjGrafico.AxisX.DrawLabels" v-model="ObjGrafico.AxisX.DrawLabels">
          </div>        
        </div>
        <div class="ZMSeparatoreScheda">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMPOSTA_TITOLO',this.LinguaUtente) }}</div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_COLORE_TITOLO',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.TitleColor}" @click="ApriPopupColorPicker(ObjGrafico.TitleColor, 'title_color')">&nbsp;</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_DIM_TESTO',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.TitleFontSize">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: 50%; justify-content: left">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 160px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_CONTORNO_TESTO',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.DrawTitleStroke">
          </div>        
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;" v-if="ObjGrafico.DrawTitleStroke">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_COLORE_CONT',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.ColorTitleStroke}" @click="ApriPopupColorPicker(ObjGrafico.ColorTitleStroke, 'title_stroke_color')">&nbsp;</label>
          </div>        
        </div>
        <div class="ZMSeparatoreScheda">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMP_ASSI',this.LinguaUtente) }}</div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_COLORE_ASSI',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.AxisX.Color}" @click="ApriPopupColorPicker(ObjGrafico.AxisX.Color, 'axes_color')">&nbsp;</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_SPESS_ASSI',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.AxisX.PenWidth" @change="ModificaSpessoreAssi()">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ASSI_COL_TXT',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.AxisX.FontColor}" @click="ApriPopupColorPicker(ObjGrafico.AxisX.FontColor, 'axes_font_color')">&nbsp;</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ASSI_DIM_TXT',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.AxisX.FontSize" @change="ModificaDimTestoAssi()">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ASSI_SPOST_MAX',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.AxisX.MaxReale" @change="ChangeAxesDimension()">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: right; margin-right: 10px">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ASSI_SUDD_GRAF',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.AxisX.NotchDim">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 160px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ASSI_MOSTRA_TXT',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.AxisX.DrawNotchLabels">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: right; margin-right: 10px">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 90%;text-align: right;">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_AUTOSCALE',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 10%; text-align: left" type="checkbox" v-model="ObjGrafico.AutoScale">
          </div>   
        </div>
        <div class="ZMSeparatoreScheda">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMP_GRIGLIA',this.LinguaUtente) }}</div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_COL_GRIGLIA',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.AxisX.NotchColor}" @click="ApriPopupColorPicker(ObjGrafico.AxisX.NotchColor, 'notch_color')">&nbsp;</label>
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_SPESS_GRIGLIA',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.AxisX.NotchPenWidth" @change="ModificaSpessoreNotch()">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_DIM_TXT_GRIGLIA',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.AxisX.NotchFontSize" @change="ModificaDimTestoNotch()">
          </div>
        </div>

        <div class="ZMSeparatoreScheda">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMP_PLACE',this.LinguaUtente) }}</div>
        
        <div class="ZMNuovaRigaScheda" style="display:flex;">

          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_COL_TITOLO',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.ColorPlaceholder}" @click="ApriPopupColorPicker(ObjGrafico.ColorPlaceholder, 'placeholder_title_color')">&nbsp;</label>
          </div>

          <div style="width:20px;float:left">&nbsp;</div>

          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_DIM_TITOLO',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" style="float: left" v-model="ObjGrafico.SizePlaceholder">
          </div>

        </div>

        <div class="ZMNuovaRigaScheda" style="display:flex;">

          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_POS_TITOLO',this.LinguaUtente) }}</label>
            <select class="form-control" v-model="ObjGrafico.PositionPlaceholder">
              <option value="T" :selected="ObjGrafico.PositionPlaceholder == ObjDirezioni.Sopra">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_SOPRA',this.LinguaUtente) }}</option>
              <option value="B" :selected="ObjGrafico.PositionPlaceholder == ObjDirezioni.Sotto">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_SOTTO',this.LinguaUtente) }}</option>
              <option value="R" :selected="ObjGrafico.PositionPlaceholder == ObjDirezioni.Destra">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_DESTRA',this.LinguaUtente) }}</option>
              <option value="L" :selected="ObjGrafico.PositionPlaceholder == ObjDirezioni.Sinistra">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_SINISTRA',this.LinguaUtente) }}</option>
            </select>
          </div>

        </div>
         
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_COL_ALLARME',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.ColorAlarmPh}" @click="ApriPopupColorPicker(ObjGrafico.ColorAlarmPh, 'ph_alarm_color')">&nbsp;</label>
          </div>
        </div>

        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_PLACE_COL_ALLARME_VUOTO',this.LinguaUtente) }}</label>
            <label class="form-control" style="width:20%; cursor: pointer" :style="{'background' : ObjGrafico.ColorAlarmEmpty}" @click="ApriPopupColorPicker(ObjGrafico.ColorAlarmEmpty, 'ph_empty_alarm_color')">&nbsp;</label>
          </div>
        </div>

      </div>

      <div v-if="TabSelezionato == Tabs.Allarmi">
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left; padding: 5px;">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 130px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI_INCLINOMETRO',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.CfgInclinometro">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right; padding: 5px;">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 130px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI_PIEZOMETRO',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.CfgPiezometro">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(60% - 10px); justify-content: left; padding: 5px;">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 130px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI_ESTENSIMETRO',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.CfgEstensimetro">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(40% - 20px); justify-content: right; padding: 5px;">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 130px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI_TEMPERATURA',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.CfgTemperatura">
          </div>
        </div>
        <div class="ZMNuovaRigaScheda" style="display:flex;">
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: left; padding: 5px;">
            <label class="ZMLabelDescriptionCheckboxPopup" style="margin-bottom: 0px; width: 130px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI_SGHEMBO',this.LinguaUtente) }}</label>
            <input class="form-control" style="margin:0px; height: 22px; width: 25px; text-align: left" type="checkbox" v-model="ObjGrafico.CfgSghembo">
          </div>
          <div style="width:20px;float:left">&nbsp;</div>
          <div class="ZMDivPopupContent" style="width: calc(50% - 10px); justify-content: right; padding: 5px;">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px">{{ this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI_ACCELEROMETRO',this.LinguaUtente) }}</label>
            <input class="form-control ZMInputNumber" type="number" v-model="ObjGrafico.CfgAccelerometro">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px; margin-left: 8px; width: 50px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO_ABBR',this.LinguaUtente) }}</label>
          </div>
        </div>
      </div>

    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="ChiudiPopup" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="ConfermaPopup" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
</template>

<script>

import { SystemInformation, POSIZIONI_TEXT_PLACEHOLDER, COLORI_PANTONE } from '@/SystemInformation';
import VUEColorPicker from '@/utils/VUEColorPicker.vue';
import VUEModal from '@/utils/VUEModal.vue';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            PopupColorPicker       : false,
            ColoreInModifica       : {},
            UsaGrassetto           : false,
            ListaMarkup            : SystemInformation.TipiMarkup,
            LinguaUtente           : SystemInformation.UserInformation.Lingua,
            Arancione              : COLORI_PANTONE.Arancione,
            Tabs                   : { 
                                       Impostazioni : this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMP', SystemInformation.UserInformation.Lingua),
                                       Allarmi      : this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_ALLARMI', SystemInformation.UserInformation.Lingua)
                                     },            
            TabSelezionato         : this.GetTraduzioneLabel('VUEPopupGraficaCatena','TKN_POPUP_GRAFICA_CATENE_IMP', SystemInformation.UserInformation.Lingua),
          }
  },
  props : ['AltezzaPopup', 'ObjGraficaCatena'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  components: { VUEModal, VUEColorPicker },
  methods :
  {
    ApriPopupColorPicker(Colore, TipoColore)
    {
      this.ColoreInModifica.Colore = Colore
      this.ColoreInModifica.Tipo = TipoColore
      this.PopupColorPicker = true
    },
    // GetSVGMarkup()
    // {
    //   let SVGMarkup = (SystemInformation.TipiMarkup.find(element => element.Nome == this.ObjGrafico.MarkupScelto)).File      
    //   SVGMarkup = SVGMarkup.replace('FILLCOLOR', this.ObjGrafico.Color)
    //   SVGMarkup = SVGMarkup.replaceAll('DIMENSIONE', this.ObjGrafico.MarkupWidth + 'px')
    //   this.ObjGrafico.SVGMarkup = 'data:image/svg+xml;base64,' + btoa(SVGMarkup)
    // },
    ConfermaColore()
    {
      switch (this.ColoreInModifica.Tipo)
      {
        case 'background'              : this.ObjGrafico.Background       = this.ColoreInModifica.Colore; break;
        case 'graph_color'             : this.ObjGrafico.Color            = this.ColoreInModifica.Colore; break;
        case 'title_color'             : this.ObjGrafico.TitleColor       = this.ColoreInModifica.Colore; break;
        case 'axes_color'              : this.ObjGrafico.AxisX.Color      = this.ColoreInModifica.Colore;
                                         this.ObjGrafico.AxisY.Color      = this.ColoreInModifica.Colore; break;
        case 'axes_font_color'         : this.ObjGrafico.AxisX.FontColor  = this.ColoreInModifica.Colore;
                                         this.ObjGrafico.AxisY.FontColor  = this.ColoreInModifica.Colore; break;
        case 'notch_color'             : this.ObjGrafico.AxisX.NotchColor = this.ColoreInModifica.Colore;
                                         this.ObjGrafico.AxisY.NotchColor = this.ColoreInModifica.Colore; break;
        case 'title_stroke_color'      : this.ObjGrafico.ColorTitleStroke = this.ColoreInModifica.Colore; break;
        case 'placeholder_title_color' : this.ObjGrafico.ColorPlaceholder = this.ColoreInModifica.Colore; break;
        case 'ph_alarm_color'          : this.ObjGrafico.ColorAlarmPh     = this.ColoreInModifica.Colore; break;
        case 'ph_empty_alarm_color'    : this.ObjGrafico.ColorAlarmEmpty  = this.ColoreInModifica.Colore; break;
      }
      this.AnnullaColore()
    },
    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },
    ModificaSpessoreAssi()
    {
      this.ObjGrafico.AxisY.PenWidth = this.ObjGrafico.AxisX.PenWidth 
    },
    ModificaDimTestoAssi()
    {
      this.ObjGrafico.AxisY.FontSize = this.ObjGrafico.AxisX.FontSize
    },
    ModificaSpessoreNotch()
    {
      this.ObjGrafico.AxisY.NotchPenWidth = this.ObjGrafico.AxisX.NotchPenWidth
    },
    ModificaDimTestoNotch()
    {
      this.ObjGrafico.AxisY.NotchFontSize = this.ObjGrafico.AxisX.NotchFontSize
    },
    ChangeAxesDimension()
    {
      this.ObjGrafico.AxisX.Min = this.ObjGrafico.AxisX.Max * -1
      this.ObjGrafico.AxisY.Min = this.ObjGrafico.AxisX.Min
      this.ObjGrafico.AxisY.Max = this.ObjGrafico.AxisX.MaxReale
    },
    ConfermaPopup()
    {
      this.$emit('OnClickConfermaPopup')
    },
    ChiudiPopup()
    {
      this.$emit('OnClickChiudiPopup')
    }
  },
  mounted() 
  {
    this.UsaGrassetto = this.ObjGrafico.AxisX.FontWeight == "bolder"
  },
  computed:
  {
    ObjGrafico:
    {
      get()
      {
        return this.ObjGraficaCatena
      }
    },

    ObjDirezioni :
    {
      get()
      {
        return POSIZIONI_TEXT_PLACEHOLDER
      }
    }
  }
}
</script>
